import React from "react";
import { default as Resume } from './Resume';

function ResumeRecruiter() {
    return (
        <Resume></Resume>
    )
}

export default ResumeRecruiter;